var $6ef9c252e9fbc070$exports = {};
$6ef9c252e9fbc070$exports = {
  "backButton": args => "Geri d\xF6n: ".concat(args.prevMenuButton),
  "moreActions": "Daha fazla eylem",
  "unavailable": "Kullan\u0131lam\u0131yor, ayr\u0131nt\u0131lar\u0131 g\xF6rmek i\xE7in geni\u015Fletin"
};
export { $6ef9c252e9fbc070$exports as default };